export const SALARY_REPORT_DETAIL_LIST_INITING = 'SALARY_REPORT_DETAIL_LIST_INITING'

export const SALARY_REPORT_DETAIL_LIST_REQUESTING = 'SALARY_REPORT_DETAIL_LIST_REQUESTING'
export const SALARY_REPORT_DETAIL_LIST_SUCCESS = 'SALARY_REPORT_DETAIL_LIST_SUCCESS'
export const SALARY_REPORT_DETAIL_LIST_ERROR = 'SALARY_REPORT_DETAIL_LIST_ERROR'

export const SALARY_REPORT_DETAIL_NVKD_REQUESTING = 'SALARY_REPORT_DETAIL_NVKD_REQUESTING'
export const SALARY_REPORT_DETAIL_NVKD_SUCCESS = 'SALARY_REPORT_DETAIL_NVKD_SUCCESS'
export const SALARY_REPORT_DETAIL_NVKD_ERROR = 'SALARY_REPORT_DETAIL_NVKD_ERROR'

export const SALARY_REPORT_DETAIL_EXPORT_XLS_REQUESTING = 'SALARY_REPORT_DETAIL_EXPORT_XLS_REQUESTING'
export const SALARY_REPORT_DETAIL_EXPORT_XLS_SUCCESS = 'SALARY_REPORT_DETAIL_EXPORT_XLS_SUCCESS'
export const SALARY_REPORT_DETAIL_EXPORT_XLS_ERROR = 'SALARY_REPORT_DETAIL_EXPORT_XLS_ERROR'

export const SALARY_REPORT_DETAIL_NVKD_API = '/api/v1/users/get_list_by_quanly'
export const SALARY_REPORT_DETAIL_LIST_API = '/api/v1/luongnhanvien/salary_report_by_store_ct'
export const SALARY_REPORT_DETAIL_EXPORT_XLS_API = '/api/v1/luongnhanvien/salary_report_export_by_store_ct' 



// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReportDetail/constants.js